import React from 'react';
import Helmet from 'react-helmet';

import { getAsset } from '../../../util/assets';
import getConfig from '../../../util/config';

const OnboardingLandingSportsHeadMeta = () => {
  const {
    app: { pageUrl },
  } = getConfig();

  return (
    <Helmet>
      <title>Your Sports Photos, Waldo-fied!</title>
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Get all your pics texted to your phone!"
      />
      <meta
        property="og:description"
        content="Hi! I’m Waldo, your photo-finding phenom at sports. I’m here to help you get all the photos of your athlete and deliver them right to your phone!"
      />
      <meta
        property="og:image"
        content={getAsset('/sports-landing-hero-1.jpg')}
      />
    </Helmet>
  );
};

export default OnboardingLandingSportsHeadMeta;
